/**
 * Utilidades puras para interpretar la respuesta del login.
 *
 * La API conserva su contrato: un rechazo de credenciales llega como HTTP 200
 * con `code: 401` en el cuerpo y sin token. El front no debe asumir que
 * `data.token` existe ni que un error HTTP trae `error.error.message`.
 */

export const LOGIN_ERROR_DEFAULT = 'Error al iniciar sesión';

export function isLoginSuccess(resp: any): boolean {
  const code = Number(resp?.code);
  return (
    Number.isFinite(code) &&
    code >= 200 &&
    code <= 299 &&
    typeof resp?.data?.token === 'string' &&
    resp.data.token.length > 0
  );
}

export function loginRejectionMessage(resp: any): string {
  const message = resp?.message;
  return typeof message === 'string' && message.trim() ? message : LOGIN_ERROR_DEFAULT;
}

export function loginHttpErrorMessage(error: any): string {
  const candidates = [error?.error?.message, error?.message];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate;
    }
  }
  return LOGIN_ERROR_DEFAULT;
}
